// @ts-nocheck
export function getDesktopBridge() {
  if (typeof window === 'undefined') return null;
  return window.artificialCareerDesktop || null;
}

export function isDesktopRuntime() {
  return Boolean(getDesktopBridge());
}
